const INIT_FILTER_VALUE = {
  address: {
    region: null,
    province: null,
    amphur: null,
    tumbol: null,
    village: null,
  },
  dataQuery: {
    dataset: null,
    section: null,
    question: null,
  },
  generalFilter: {
    ageGroups: [],
    problemConditions: [],
    verifiedStatus: "passed",
  },
  scope: "ครัวเรือน",
  filter_change: null,
};

const state = () => {
  return JSON.parse(JSON.stringify(INIT_FILTER_VALUE));
};

// actions
const actions = {
  clearStore({ commit }) {
    commit("clearStore");
  },
  setStore({ commit }, store) {
    commit("setStore", store);
  },
  setScope({ commit }, scope) {
    commit("setScope", scope);
  },
  setFilterChange({ commit }, val) {
    commit("setFilterChange", val);
  },
};

// mutations
const mutations = {
  clearStore(state) {
    Object.assign(state, JSON.parse(JSON.stringify(INIT_FILTER_VALUE)));
  },
  setStore(state, store) {
    Object.assign(state, store);
  },
  setScope(state, scope) {
    state.scope = scope;
  },
  setFilterChange(state, val) {
    state.filter_change = val;
  },
};

// getters
const getters = {
  region: (state) => state.address.region,
  filterChange: (state) => state.filter_change,
  province: (state) => state.address.province,
  dataQuery: (state) => state.dataQuery,
  generalFilter: (state) => state.generalFilter,
  scope: (state) => state.scope,
  getAllFilter: (state) => state,
  getFilterSummary: (state) => {
    const result = [];
    if (state.address.region) result.push(state.address.region);
    if (state.address.province) result.push(state.address.province.province_name);
    if (state.address.amphur) result.push(state.address.amphur.amphur_name);
    if (state.address.tumbol) result.push(state.address.tumbol.tumbol_name);
    if (state.address.village) result.push(state.address.village.village_name);
    return result;
  },
  getFilterForApi: (state) => {
    const result = {};
    if (state.address.region) result.sector = state.address.region;
    if (state.address.province) result.province_id = state.address.province._id.province_ID;
    if (state.address.amphur) result.amphur_id = state.address.amphur._id.amphur_ID;
    if (state.address.tumbol) result.tambol_id = state.address.tumbol._id.tumbol_ID;
    if (state.address.village) result.village_id = state.address.village._id.village_ID;
    if (state.scope) result.unit = state.scope;
    const verified = state.generalFilter.verifiedStatus === "passed" ? true : "all";
    result.is_verified = verified;
    result.is_verified_member = verified;
    result.is_verified_neet = verified;
    result.is_verified_cwd = verified;
    return result;
  },
  getFilterForApiWithAgeGroups: (state, getters) => {
    const result = { ...getters.getFilterForApi };
    if (state.generalFilter.ageGroups?.length) result.age_groups = JSON.stringify(state.generalFilter.ageGroups);
    return result;
  },
  getFilterForApiNeets: (state, getters) => {
    const result = { ...getters.getFilterForApi };
    delete result.is_verified_cwd;
    return result;
  },
  getFilterForApiDisability: (state, getters) => {
    const result = { ...getters.getFilterForApi };
    delete result.is_verified_neet;
    return result;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
